import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import { toast } from "sonner";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import profileImage from "../../assets/images/no-profile-picture.png";
import {
  createStudent,
  getStudentDetails,
  updateStudent,
  getClassesList,
  getDivisionSectionList,
} from "../../services/Academic-Services.js";
import { getUserList } from "../../services/Users-services";
import {
  callToast,
  showErrorMessages,
} from "../../../src/services/utilityFunctions.js";
import { useGlobalState } from "../../../src/services/hostelConst";
import Select from "react-select";
import { getLocalStorageData } from "../../services/axiosComponent";
import { selectStyle } from "../../services/constant";
import {
  openModal,
  closeModal,
} from "../../services/redux/reducers/modalSlice";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";

const AddStudentForm = ({ navigate, refresh }) => {
  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(modal.isEditing);

  // Options for dropdowns
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [studentOptions, setStudentOptions] = useState([]);

  // Loading states for dropdowns
  const [isClassOptionsLoading, setIsClassOptionsLoading] = useState(false);
  const [isSectionOptionsLoading, setIsSectionOptionsLoading] = useState(false);
  const [isStudentLoading, setIsStudentLoading] = useState(false);

  const prepareFormData = (data = null) => {
    return {
      classId: {
        value: data != null ? data["_CLASS"] : "",
        label: data != null ? data["CLASS"] : "",
      },
      sectionId: {
        value: data != null ? data["_SECTION"] : "",
        label: data != null ? data["SECTION"] : "",
      },
      studentId: {
        value: data != null ? data["_ID"] : "",
        label: data != null ? data["NAME"] : "",
      },
      registrationDate:
        data != null ? dayjs(data["REGISTRATION_DATE"]) : dayjs(),
    };
  };

  const [formData, setFormData] = useState(prepareFormData());

  const getStudentDetailData = async (entityId) => {
    setLoadingData(true);
    var res = await getStudentDetails(entityId);
    if (res.status == "success") {
      console.log(res, "get student details");
      setFormData(prepareFormData(res.data));

      // Load dependent dropdowns
      //   if (res.data["_CLASS"]) {
      //     await getClassListData();
      //     await getSectionListData(res.data["_CLASS"]);
      //     await getStudentListData(res.data["_CLASS"], res.data["_SECTION"]);
      //   }
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingData(false);
  };

  const handleChange = (field, value) => {
    setErrors({});

    if (field == "classId") {
      setFormData((prev) => ({
        ...prev,
        sectionId: { value: "", label: "" },
        studentId: { value: "", label: "" },
      }));
    }

    if (field == "sectionId") {
      setFormData((prev) => ({
        ...prev,
        studentId: { value: "", label: "" },
      }));
    }

    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateFields = () => {
    let isValid = true;
    let errors = {};

    if (formData.studentId.value == "") {
      isValid = false;
      errors.studentId = "Student is required";
    }

    if (formData.sectionId.value == "") {
      isValid = false;
      errors.section = "Section is required";
    }

    if (formData.classId.value == "") {
      isValid = false;
      errors.class = "Class is required";
    }

    if (!formData.registrationDate) {
      isValid = false;
      errors.registrationDate = "Registration Date is required";
    }

    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (validateFields()) {
      setLoading(true);

      var submitData = {
        userId: formData.studentId.value,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
        classId: formData.classId.value,
        sectionId: formData.sectionId.value,
        registrationDate: formData.registrationDate.format("DD/MM/YYYY"),
        id: modal.isEditing ? modal.data._ID : null,
        regionId: formData.classId._REGION,
        siteId: formData.classId._SITE,
      };

      var res = modal.isEditing
        ? await updateStudent(submitData)
        : await createStudent(submitData);

      if (res.status == "success") {
        callToast(
          "success",
          modal.isEditing ? "Updated" : "Created",
          modal.isEditing
            ? "Student details updated"
            : "Student added successfully"
        );

        await refresh({ columnRefresh: false, isLoading: false });
        setLoading(false);
        dispatch(closeModal());
      } else {
        console.log(res, "add Student response");
        setLoading(false);
        showErrorMessages({
          data: res,
          navigate,
        });
      }
    }
  };

  const getClassListData = async (query = "") => {
    setIsClassOptionsLoading(true);
    try {
      var res = await getClassesList({ query });
      if (res.status == "success") {
        var list = [];
        res.data.entityList.map((item) => {
          list.push({
            _REGION: item._REGION,
            _SITE: item._SITE,
            value: item._ID,
            label: item.NAME,
          });
        });
        setClassOptions(list);
      } else {
        showErrorMessages({ data: res, navigate });
      }
    } catch (error) {
      console.error("Error fetching class list:", error);
    }
    setIsClassOptionsLoading(false);
  };

  const getSectionListData = async (classId, query = "") => {
    if (!classId) return;

    setIsSectionOptionsLoading(true);
    try {
      var res = await getDivisionSectionList({ classId, query });
      if (res.status == "success") {
        var list = [];
        res.data.entityList.map((item) => {
          list.push({
            value: item._ID,
            label: item.NAME,
          });
        });
        setSectionOptions(list);

        if (list.length == 0) {
          setErrors((prev) => ({
            ...prev,
            section: "No sections available for this class",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            section: "",
          }));
        }
      } else {
        showErrorMessages({ data: res, navigate });
      }
    } catch (error) {
      console.error("Error fetching section list:", error);
    }
    setIsSectionOptionsLoading(false);
  };

  const getStudentListData = async (query = "", classId, sectionId) => {
    if (!classId || !sectionId) return;

    setIsStudentLoading(true);
    try {
      var res = await getUserList({
        query,
        classId,
        sectionId,
        status: "Y",
      });
      if (res.status == "success") {
        var list = [];
        res.data.entityList.map((item) => {
          list.push({
            value: item._ID,
            label: item.NAME,
          });
        });
        setStudentOptions(list);
      } else {
        showErrorMessages({ data: res, navigate });
      }
    } catch (error) {
      console.error("Error fetching student list:", error);
    }
    setIsStudentLoading(false);
  };

  useEffect(() => {
    getClassListData();

    if (modal.isEditing == true) {
      getStudentDetailData(modal.data._ID);
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div className="">
            <div className="d-flex">
              <div className="w-100 ps-5 pe-5">
                <form>
                  <>
                    <div className="mb-3">
                      <label className="form-label">Class</label>
                      <Select
                        styles={selectStyle}
                        options={classOptions}
                        value={
                          formData.classId.label == "" ? null : formData.classId
                        }
                        components={
                          isClassOptionsLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "classId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                          if (newValue != null) {
                            getSectionListData(newValue.value);
                          }
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                            getClassListData(inputValue);
                          }
                        }}
                        isSearchable={true}
                        placeholder="Select Class"
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.class && (
                        <small className="text-danger">{errors.class}</small>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Section</label>
                      <Select
                        styles={selectStyle}
                        options={sectionOptions}
                        value={
                          formData.sectionId.label == ""
                            ? null
                            : formData.sectionId
                        }
                        components={
                          isSectionOptionsLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "sectionId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                          if (newValue != null) {
                            getStudentListData(
                              "",
                              formData.classId.value,
                              newValue.value
                            );
                          }
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (
                            action === "input-change" &&
                            formData.classId.value
                          ) {
                            getSectionListData(
                              formData.classId.value,
                              inputValue
                            );
                          }
                        }}
                        isSearchable={true}
                        placeholder="Select Section"
                        className="basic-single"
                        classNamePrefix="select"
                        isDisabled={formData.classId.value === ""}
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.section && (
                        <small className="text-danger">{errors.section}</small>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Student</label>
                      <Select
                        styles={selectStyle}
                        options={studentOptions}
                        value={
                          formData.studentId.label == ""
                            ? null
                            : formData.studentId
                        }
                        components={
                          isStudentLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "studentId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                            getStudentListData(
                              inputValue,
                              formData.classId.value,
                              formData.sectionId.value
                            );
                          }
                          // Optional: Add filtering logic here if needed
                        }}
                        noOptionsMessage={() => {
                          return formData.sectionId.value === ""
                            ? "Please select class and section first"
                            : "No students available";
                        }}
                        isSearchable={true}
                        placeholder="Select Student"
                        className="basic-single"
                        classNamePrefix="select"
                        isDisabled={
                          formData.sectionId.value === "" ||
                          formData.classId.value === ""
                        }
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.studentId && (
                        <small className="text-danger">
                          {errors.studentId}
                        </small>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Registration Date</label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={formData.registrationDate}
                          onChange={(newValue) => {
                            handleChange("registrationDate", newValue);
                          }}
                          className="form-control"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              fullWidth: true,
                            },
                          }}
                        />
                      </LocalizationProvider>
                      {errors.registrationDate && (
                        <small className="text-danger">
                          {errors.registrationDate}
                        </small>
                      )}
                    </div>
                  </>

                  <div className="d-flex justify-content-end mt-4 gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        className="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default AddStudentForm;
